import { createContext, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { RoutePath } from '../../../layout/Routes'

import { CandidatesContextControllerProps, CandidatesContextType } from './CandidatesContext.types'

export const CandidatesContext = createContext<CandidatesContextType | undefined>(undefined)

// Provides data for all types of candidates tables
// Created to avoid prop drilling since most of the components will operate on the same endpoint
export function CandidatesContextController({
  children,
  program,
  queryParams,
  setQueryParams,
  sort,
  candidates
}: CandidatesContextControllerProps) {
  const navigate = useNavigate()
  const { id, name } = program

  // Shared by most of the table components, move/remove if needed
  const navigateToCandidate = useCallback(
    (candidateId: string) =>
      navigate(
        {
          pathname: `${RoutePath.GRANT_PROGRAMS}/${id}/candidates/${candidateId}`
        },
        {
          state: {
            organisationName: name
          }
        }
      ),
    [navigate, id, name]
  )

  const value = useMemo(
    () => ({
      program,
      queryParams,
      setQueryParams,
      sort,
      candidates,
      navigateToCandidate
    }),
    [program, queryParams, setQueryParams, sort, candidates, navigateToCandidate]
  )

  return <CandidatesContext.Provider value={value}>{children}</CandidatesContext.Provider>
}
